var DOC = document;

var TabsInitializer = function (el, options) {
	var CORE = {

		$el: $(el),

		toggle: {

			elements: null,

			disable: function () {
				var self = CORE.toggle;
				var i = 0;

				if (self.elements === null) {
					return false;
				}

				for (i; i < self.elements.length; i++){
					$(self.elements[i]).removeClass(options.classNames.toggle + '--active');
				}
				return true;

			},

			onMouseenter: function (e) {
				var tab = e.currentTarget.__tabHolder;

				CORE.toggle.disable();
				CORE.tab.disable();

				$(tab).addClass(options.classNames.tab + '--active');
				$(this).addClass(options.classNames.toggle + '--active');

			},

			construct: function (tab) {
				var els = tab.getElementsByClassName(options.classNames.toggle);
				var i = 0;

				if (els == null || typeof els !== 'object' || !('length' in els) || !els.length) {
					return false;
				}

				if( CORE.toggle.elements === null ){
					CORE.toggle.elements = [];
				}

				for (i; i < els.length; i++){
					CORE.toggle.elements[CORE.toggle.elements.length] = els[i];
					els[i].addEventListener(options.action, CORE.toggle.onMouseenter);
					els[i].__tabHolder = tab;
				}

			}

		},

		tab: {

			elements: null,

			disable: function () {
				var self = CORE.tab;
				var i = 0;

				if (self.elements === null) {
					return false;
				}

				for (i; i < self.elements.length; i++){
					$(self.elements[i]).removeClass(options.classNames.tab + '--active');
				}
				return true;

			},

			construct: function () {
				var els = el.getElementsByClassName(options.classNames.tab);
				var i = 0;

				if (els == null || typeof els !== 'object' || !('length' in els) || !els.length) {
					return false;
				}

				if( CORE.tab.elements === null ){
					CORE.tab.elements = [];
				}

				for (i; i < els.length; i++){
					CORE.tab.elements[CORE.tab.elements.length] = els[i];
					CORE.toggle.construct(els[i]);
				}

			}

		}

	};

	CORE.tab.construct();
};

var Tabs = function(options){
	var els;
	var i = 0;

	if (typeof options !== 'object' || options == null) {
		options = {};
	}
	options.prefix = 'prefix' in options && typeof options.prefix === 'string' ? options.prefix : 'tabs';
	options.action = 'action' in options && options.action === 'hover' ? 'mouseenter' : 'click';
	options.classNames = {
		tabs: options.prefix + '--holder',
		tab: options.prefix + '__tab',
		toggle: options.prefix + '__toggle'
	};
	els = DOC.getElementsByClassName(options.classNames.tabs);

	if (els == null || typeof els !== 'object' || !('length' in els) || !els.length) {
		return false;
	}

	for (i; i < els.length; i++){
		TabsInitializer(els[i], options);

	}

}

export default Tabs;